var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_218",
    "data-name": "Group 218",
    transform: "translate(-11746.666 -2998)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_75",
    "data-name": "Rectangle 75",
    width: 60,
    height: 60,
    transform: "translate(11746.666 2998)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_217",
    "data-name": "Group 217"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_216",
    "data-name": "Group 216"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M11798.821,3036.346a6.072,6.072,0,0,0-5.831,4.409h-5.853V3034.3h5.976a11.771,11.771,0,0,0,3.419-23.034,13.456,13.456,0,0,0-13.034-10.184,13.311,13.311,0,0,0-6.737,1.8,18.039,18.039,0,1,0-16.541,31.414h5.976v6.454h-5.853a6.063,6.063,0,1,0,0,3.307h7.506a1.653,1.653,0,0,0,1.653-1.653V3034.3h5.511v9.992a6.062,6.062,0,1,0,3.308,0V3034.3h5.511v8.108a1.653,1.653,0,0,0,1.653,1.653h7.506a6.061,6.061,0,1,0,5.831-7.716Zm-44.31,8.818a2.755,2.755,0,1,1,2.755-2.755A2.759,2.759,0,0,1,11754.512,3045.164Zm24.91,4.96a2.755,2.755,0,1,1-2.755-2.756A2.759,2.759,0,0,1,11779.422,3050.124Zm-19.2-19.129a8.464,8.464,0,0,1-1.231-16.838,1.653,1.653,0,0,0,1.406-1.789c-.023-.258-.035-.522-.035-.784a8.466,8.466,0,0,1,14.9-5.494,1.654,1.654,0,0,0,2.243.259,10,10,0,0,1,5.991-1.959,10.147,10.147,0,0,1,9.994,8.49,1.651,1.651,0,0,0,1.3,1.355,8.464,8.464,0,0,1-1.682,16.759h-32.894Zm38.6,14.169a2.755,2.755,0,1,1,2.756-2.755A2.758,2.758,0,0,1,11798.821,3045.164Z",
    fill: "#18c99d"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloud);
export default __webpack_public_path__ + "static/media/icon-cloud.3ad6b10bb172f0a1570217a1a54544e3.svg";
export { ForwardRef as ReactComponent };